import { installOfflineMock } from './install';

installOfflineMock();
